module.exports = __webpack_public_path__ + "static/media/resume.014a4c2a.png";